// @flow

import { type UserInputValidationError } from '@tectonics/prs/validation';

export function validateIndiaPhone(phoneNumberValue: string): ?UserInputValidationError {
  if(phoneNumberValue.trim() === '' || !phoneNumberValue) {
    return undefined;
  }

  if(phoneNumberValue.length < 8) {
    return { id: 'min-length' };
  }
  if(!parseInt(phoneNumberValue)) {
    return { id: 'only-numbers' };
  }
}
